/**
 * Phase 25: RouteFallback
 *
 * Shown by <Suspense> while a lazily-loaded route chunk is being fetched.
 * Centered spinner, consistent with the app's other loading states (e.g.
 * the Billing section's "Loading subscription…").
 *
 * Kept intentionally tiny so it's part of the main bundle, not a chunk —
 * the fallback must be instantly available.
 */

import { Loader } from 'lucide-react';

export function RouteFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="flex items-center gap-2 text-ink-tertiary">
        <Loader className="w-5 h-5 animate-spin" />
        <span className="text-sm">Loading…</span>
      </div>
    </div>
  );
}
